export default __webpack_public_path__ + "static/media/RU.ebbc4534.svg";